var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAttachMoney(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10970_3854",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10970_3854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.877 41.5V37.396C21.041 37.1397 19.5178 36.4917 18.3075 35.452C17.0975 34.4123 16.2193 33.0808 15.673 31.4575L17.7805 30.5575C18.3728 32.1065 19.1991 33.2727 20.2595 34.056C21.3198 34.8393 22.6385 35.231 24.2155 35.231C25.8281 35.231 27.2185 34.8213 28.3865 34.002C29.5545 33.1827 30.1385 31.9897 30.1385 30.423C30.1385 28.905 29.6576 27.7172 28.696 26.8595C27.7346 26.0018 26.0001 25.1628 23.4925 24.3425C21.1051 23.5758 19.3391 22.6103 18.1945 21.446C17.0495 20.282 16.477 18.7885 16.477 16.9655C16.477 15.1962 17.1038 13.7205 18.3575 12.5385C19.6115 11.3565 21.118 10.7078 22.877 10.5925V6.5H25.146V10.5925C26.5563 10.7205 27.7806 11.1288 28.819 11.8175C29.8576 12.5058 30.686 13.4448 31.304 14.6345L29.2345 15.604C28.7421 14.6397 28.0851 13.9095 27.2635 13.4135C26.4418 12.9172 25.3911 12.669 24.1115 12.669C22.5655 12.669 21.2846 13.0512 20.269 13.8155C19.2536 14.5795 18.746 15.6192 18.746 16.9345C18.746 18.2142 19.214 19.2617 20.15 20.077C21.086 20.8923 22.9103 21.7232 25.623 22.5695C27.9666 23.3205 29.6833 24.3095 30.773 25.5365C31.8626 26.7635 32.4075 28.345 32.4075 30.281C32.4075 32.2783 31.7651 33.8993 30.4805 35.144C29.1961 36.389 27.418 37.1435 25.146 37.4075V41.5H22.877Z",
    fill: "#1C1B1F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachMoney);
export default __webpack_public_path__ + "static/media/attach_money.1c3c136921247698a9a91ba654a0fcc8.svg";
export { ForwardRef as ReactComponent };